module.exports = __webpack_public_path__ + "img/1482022414.89c1df57.jpg";